import { PATCH } from "../../APiHelper/API"


export const moveTeam = (team_id, new_league_id, onSuccess, onError) => {
    const data = {
        new_league_id: new_league_id
    }
    PATCH(`/api/v1/leagues/team/${team_id}`, data, onSuccess, onError)
}